module.exports = __webpack_public_path__ + "img/48CH_PulseAlarm.207ebe11.png";